import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppMainComponent } from './app.main.component';
import { NotFoundComponent } from './pages/error-pages/not-found/not-found.component';
import { AuthGuard } from './security/guards/auth.guard';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'game',
        pathMatch: 'full'
    },
    {
        path: 'game',
        canActivate: [AuthGuard],
        children: [{
            path: '',
            loadChildren: () => import('./modules/page-home/page-home.module').then((p) => p.PageHomeModule)
        }]
    },
    {
        path: 'presorteo',
        canActivate: [AuthGuard],
        component: AppMainComponent,
        loadChildren: () => import('./modules/modules.module').then(m => m.ModulesModule)
    },
    {
        path: 'security',
        loadChildren: () => import('./security/security.module').then(m => m.SecurityModule)
    },
    {
        path: '404',
        canActivate: [AuthGuard],
        component: AppMainComponent,
        children:[
            {
                path:'',
                component: NotFoundComponent
            }
        ]
    },
    {
        path: '**',
        redirectTo: '404',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }


